import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ComplaintState {
  verifyStatus: "idle" | "loading" | "found" | "not-found" | "error";
  submitStatus: "idle" | "loading" | "success" | "error";
  verifiedTicketId: string | null;
  verifiedLoanAccountNumber: string | null;
  verifyMessage: string | null;
  newTicketId: string | null;
  errorMessage: string | null;
}

const initialState: ComplaintState = {
  verifyStatus: "idle",
  submitStatus: "idle",
  verifiedTicketId: null,
  verifiedLoanAccountNumber: null,
  verifyMessage: null,
  newTicketId: null,
  errorMessage: null,
};

const complaintSlice = createSlice({
  name: "complaint",
  initialState,
  reducers: {
    setVerifyLoading: (state) => {
      state.verifyStatus = "loading";
      state.errorMessage = null;
    },
    setVerifyFound: (state, action: PayloadAction<{ ticketId: string; lan: string }>) => {
      state.verifyStatus = "found";
      state.verifiedTicketId = action.payload.ticketId;
      state.verifiedLoanAccountNumber = action.payload.lan;
    },
    setVerifyNotFound: (state, action: PayloadAction<string | undefined>) => {
      state.verifyStatus = "not-found";
      state.verifyMessage = action.payload ?? null;
    },
    setVerifyError: (state, action: PayloadAction<string>) => {
      state.verifyStatus = "error";
      state.errorMessage = action.payload;
    },
    resetVerify: (state) => {
      state.verifyStatus = "idle";
      state.verifiedTicketId = null;
      state.verifiedLoanAccountNumber = null;
      state.verifyMessage = null;
      state.errorMessage = null;
    },
    setSubmitLoading: (state) => {
      state.submitStatus = "loading";
      state.errorMessage = null;
    },
    setSubmitSuccess: (state, action: PayloadAction<string>) => {
      state.submitStatus = "success";
      state.newTicketId = action.payload;
    },
    setSubmitError: (state, action: PayloadAction<string>) => {
      state.submitStatus = "error";
      state.errorMessage = action.payload;
    },
    resetSubmit: (state) => {
      state.submitStatus = "idle";
      state.newTicketId = null;
      state.errorMessage = null;
    },
    resetAll: () => initialState,
  },
});

export const {
  setVerifyLoading,
  setVerifyFound,
  setVerifyNotFound,
  setVerifyError,
  resetVerify,
  setSubmitLoading,
  setSubmitSuccess,
  setSubmitError,
  resetSubmit,
  resetAll,
} = complaintSlice.actions;

export default complaintSlice.reducer;
